import * as ActionTypes from "./types";
import { actionCreator } from '../helpers/actionCreator';

export const signalRInfo = actionCreator(ActionTypes.SIGNAL_R_INFO);
export const signalRDisconnect = actionCreator(ActionTypes.SIGNAL_R_DISCONNECT);
